export default __webpack_public_path__ + "static/Emailgate_Default-74f0e5c32964a6a9a0f2168900f23ce3.png";